<template>
  <md-dialog
    v-model="visible"
    custom-class="overdue-reasons-force-control-reminder-dialog"
    width="640px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="overdue-reasons-force-control-reminder-dialog__header">
      <div class="overdue-reasons-force-control-reminder-dialog__header-title">
        <md-icon class="overdue-reasons-force-control-reminder-dialog__header-icon">
          <warning />
        </md-icon>
        <span class="overdue-reasons-force-control-reminder-dialog__header-text">
          逾期订单风险管控-待办任务强制提醒
        </span>
      </div>
      <button
        type="button"
        class="overdue-reasons-force-control-reminder-dialog__close"
        aria-label="关闭"
        @click="handleCloseClick"
      >
        <span class="overdue-reasons-force-control-reminder-dialog__close-icon">×</span>
      </button>
    </div>

    <div class="overdue-reasons-force-control-reminder-dialog__content">
      <div class="overdue-reasons-force-control-reminder-dialog__summary">
        <span class="overdue-reasons-force-control-reminder-dialog__summary-text">
          您好，截止当前，以下订单逾期未兑现超6小时且无备注原因共
        </span>
        <span class="overdue-reasons-force-control-reminder-dialog__summary-count">{{ taskCount }}</span>
        <span class="overdue-reasons-force-control-reminder-dialog__summary-text">个</span>
      </div>

      <div class="overdue-reasons-force-control-reminder-dialog__stat">
        <div class="overdue-reasons-force-control-reminder-dialog__stat-card">
          <div class="overdue-reasons-force-control-reminder-dialog__stat-label">发车超时</div>
          <div class="overdue-reasons-force-control-reminder-dialog__stat-value">{{ taskCount }}</div>
        </div>
      </div>

      <div class="overdue-reasons-force-control-reminder-dialog__actions">
        <button
          type="button"
          class="overdue-reasons-force-control-reminder-dialog__btn-remark"
          @click="handleGoRemark"
        >
          逾期备注跳转
        </button>
        <button
          type="button"
          class="overdue-reasons-force-control-reminder-dialog__btn-download"
          :disabled="downloading"
          @click="handleDownload"
        >
          {{ downloading ? '下载中...' : '明细下载' }}
        </button>
      </div>

      <div class="overdue-reasons-force-control-reminder-dialog__alert">
        <div class="overdue-reasons-force-control-reminder-dialog__alert-main">
          <md-icon class="overdue-reasons-force-control-reminder-dialog__alert-icon">
            <warning />
          </md-icon>
          <div class="overdue-reasons-force-control-reminder-dialog__alert-text">
            <p>
              <span class="overdue-reasons-force-control-reminder-dialog__alert-emphasis">请立即处理</span>
              ，如有异常情况无法闭环的，务必先操作订单逾期备注，避免客诉。
            </p>
            <p class="overdue-reasons-force-control-reminder-dialog__alert-strong">
              如产生客诉按单严肃追责！
            </p>
          </div>
        </div>
        <div class="overdue-reasons-force-control-reminder-dialog__contact">
          <md-icon class="overdue-reasons-force-control-reminder-dialog__contact-icon">
            <cellphone-filled />
          </md-icon>
          <span>如有疑问；大件请联系：李柏青libq75、快消请联系：谢青xieqing1</span>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CellphoneFilled, Warning } from '@mdesign3/icons-vue';
import { MdDialog, MdIcon } from 'mdesign3';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    taskCount: number;
    downloading?: boolean;
  }>(),
  {
    downloading: false,
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'goRemark'): void;
  (e: 'download'): void;
  (e: 'closeButtonClick'): void;
}>();

const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const handleCloseClick = () => {
  // 仅通知父级关闭，由父级更新 modelValue，避免先改 v-model 导致埋点判断 dialogVisible 已为 false
  emit('closeButtonClick');
};

const handleGoRemark = () => {
  emit('goRemark');
};

const handleDownload = () => {
  emit('download');
};
</script>

<style lang="less">
.overdue-reasons-force-control-reminder-dialog {
  z-index: 200000000 !important;
  border-radius: 16px;
  overflow: hidden;

  .md-dialog__header {
    display: none;
  }

  .md-dialog__body {
    padding: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 20px;
    background: linear-gradient(180deg, #fff8f0 0%, #fff3e8 100%);
  }

  &__header-title {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1;
  }

  &__header-icon {
    flex-shrink: 0;
    font-size: 20px;
    color: #faad14;
  }

  &__header-text {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #e67a2e;
  }

  &__close {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #a67c52;
  }

  &__close-icon {
    font-size: 22px;
    font-weight: 400;
    line-height: 1;
    font-family: Arial, sans-serif;
  }

  &__close:hover {
    color: #e67a2e;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 20px 20px;
  }

  &__summary {
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 14px 16px;
    border-radius: 12px;
    background: #fff3e8;
    text-align: center;
  }

  &__summary-text {
    font-size: 14px;
    line-height: 22px;
    color: #8c5a2b;
  }

  &__summary-count {
    font-size: 32px;
    font-weight: 700;
    line-height: 1;
    color: #ff6b00;
  }

  &__stat {
    display: flex;
    justify-content: center;
  }

  &__stat-card {
    min-width: 120px;
    padding: 14px 24px;
    border: 1px solid #eef0f3;
    border-radius: 12px;
    background: #fafbfc;
    text-align: center;
  }

  &__stat-label {
    margin-bottom: 8px;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    color: #4e5969;
  }

  &__stat-value {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    color: #ff4d00;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 4px 0 8px;
  }

  &__btn-remark,
  &__btn-download {
    min-width: 168px;
    height: 44px;
    padding: 0 28px;
    border: 1px solid #e3e8ef;
    border-radius: 999px;
    background: #fff;
    box-shadow: none;
    outline: none;
    font-size: 15px;
    font-weight: 500;
    line-height: 42px;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;

    &:hover:not(:disabled) {
      border-color: #d5dbe3;
      background: #fafbfc;
    }

    &:active:not(:disabled) {
      background: #f5f7fa;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.65;
    }
  }

  &__btn-remark {
    color: #f53f3f;
  }

  &__btn-download {
    color: #3d4a5c;
  }

  &__alert {
    padding: 14px 16px 12px;
    border-radius: 12px;
    border-left: 4px solid #ff8f1f;
    background: #fffbe8;
  }

  &__alert-main {
    display: flex;
    gap: 8px;
    align-items: flex-start;
  }

  &__alert-icon {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 16px;
    color: #faad14;
  }

  &__alert-text {
    margin: 0;
    font-size: 13px;
    line-height: 22px;
    color: #4e5969;

    p {
      margin: 0;
    }
  }

  &__alert-emphasis {
    color: #f53f3f;
    font-weight: 600;
  }

  &__alert-strong {
    margin-top: 4px !important;
    color: #f53f3f;
    font-weight: 600;
  }

  &__contact {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #e5e6eb;
    font-size: 13px;
    line-height: 20px;
    color: #86909c;
  }

  &__contact-icon {
    font-size: 14px;
    color: #f53f3f;
  }
}
</style>
